export default "/assets/standing-14-bronzing.cae1e97c3f2edcc68ff0dbd433ac343a.jpg";